import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LegalNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-6">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Legal Notice</h1>
          <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Company Information</h2>
              <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-gray-700 mb-2"><strong>Company Name:</strong> PROBUILD MARKET LIMITED</p>
                <p className="text-gray-700 mb-2"><strong>Reg. Numb.:</strong> 796855</p>
                <p className="text-gray-700 mb-2"><strong>Registered Address:</strong></p>
                <p className="text-gray-700 ml-4 mb-2">THE BLACK CHURCH, ST. MARY'S PLACE</p>
                <p className="text-gray-700 ml-4 mb-2">DUBLIN 7, D07 P4AX</p>
                <p className="text-gray-700 ml-4 mb-3">IRELAND</p>
                <p className="text-gray-700 mb-2">
                  <strong>Email:</strong> <a href="mailto:contact@probuildmarket.net" className="text-blue-600 hover:underline">contact@probuildmarket.net</a>
                </p>
                <p className="text-gray-700"><strong>Website:</strong> probuildmarket.com</p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Terms of Use</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                By accessing and using the PROBUILD MARKET platform operated by PROBUILD MARKET LIMITED, 
                you agree to comply with and be bound by the following terms and conditions.
              </p>
              
              <h3 className="text-xl font-medium text-gray-800 mb-3">2.1 Acceptable Use</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                You agree to use our platform only for lawful purposes and in accordance with these terms. 
                You must not use the platform:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mb-4">
                <li>In any way that violates applicable laws or regulations</li>
                <li>To transmit harmful or malicious code</li>
                <li>To infringe upon the rights of others</li>
                <li>To engage in fraudulent activities</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-800 mb-3">2.2 User Accounts</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                You are responsible for maintaining the confidentiality of your account credentials and 
                for all activities that occur under your account. You must notify us immediately of any 
                unauthorized use of your account.
              </p>

              <h3 className="text-xl font-medium text-gray-800 mb-3">2.3 Business Transactions</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                PROBUILD MARKET acts as a platform connecting buyers and suppliers. We are not party to 
                the actual transactions between users. All contracts are formed directly between buyers 
                and suppliers.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                All content, trademarks, logos, and data on this platform, including but not limited to 
                software, databases, text, graphics, icons, and hyperlinks, are the property of or licensed 
                to PROBUILD MARKET LIMITED and are protected by Irish and international intellectual 
                property laws.
              </p>
              <p className="text-gray-700 leading-relaxed">
                You may not reproduce, distribute, modify, or create derivative works from any content 
                without our express written permission.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                To the fullest extent permitted by Irish law, PROBUILD MARKET LIMITED shall not be 
                liable for:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Any indirect, incidental, special, consequential, or punitive damages</li>
                <li>Loss of profits, revenue, data, or business opportunities</li>
                <li>Damages arising from transactions between platform users</li>
                <li>Service interruptions or technical issues</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Warranties and Disclaimers</h2>
              <p className="text-gray-700 leading-relaxed">
                The platform is provided "as is" without warranties of any kind, either express or implied. 
                We do not guarantee that the platform will be uninterrupted, secure, or error-free.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Governing Law and Jurisdiction</h2>
              <p className="text-gray-700 leading-relaxed">
                These terms shall be governed by and construed in accordance with the laws of Ireland. 
                Any disputes arising from these terms or your use of the platform shall be subject to the 
                exclusive jurisdiction of the courts of Dublin, Ireland.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Dispute Resolution</h2>
              <p className="text-gray-700 leading-relaxed">
                We encourage users to contact us directly to resolve any disputes. If a dispute cannot be 
                resolved amicably, parties may seek resolution through mediation before pursuing legal action.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these terms at any time. Changes will be effective immediately 
                upon posting to the website. Your continued use of the platform after changes constitutes 
                acceptance of the modified terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Severability</h2>
              <p className="text-gray-700 leading-relaxed">
                If any provision of these terms is found to be invalid or unenforceable, the remaining 
                provisions shall continue in full force and effect.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                For legal inquiries or questions about these terms, please contact us at:
              </p>
              <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-gray-700 font-semibold mb-2">PROBUILD MARKET LIMITED</p>
                <p className="text-gray-700">THE BLACK CHURCH, ST. MARY'S PLACE</p>
                <p className="text-gray-700">DUBLIN 7, D07 P4AX</p>
                <p className="text-gray-700">IRELAND</p>
                <p className="text-gray-700 mt-3">Reg. Numb.: 796855</p>
                <p className="text-gray-700 mt-3">
                  Email: <a href="mailto:contact@probuildmarket.net" className="text-blue-600 hover:underline">contact@probuildmarket.net</a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;